import React from 'react'

import { setIsMessageModalOpen, setMessageModalContent } from '../../store/ui/uiSlice'
import Modal from '../Modal/Modal'
import * as Styled from './styles'
import { useAppDispatch, useAppSelector } from '../../hooks'

const Message: React.FC = () => {
  const dispatch = useAppDispatch()

  const {
    isMessageModalOpen,
    messageModalContent: { dangerouslySetMessage },
  } = useAppSelector((state) => state.ui)

  return (
    <Modal
      isOpen={isMessageModalOpen}
      onRequestClose={() => {
        dispatch(setIsMessageModalOpen(false))
        dispatch(setMessageModalContent({ dangerouslySetMessage: '' }))
      }}
      contentLabel="Information" // only for screenreaders
    >
      <Styled.ModalMessage dangerouslySetInnerHTML={{ __html: dangerouslySetMessage }} />
    </Modal>
  )
}

export default Message
